/**
 *  Sagas for the voting resource managment using Swagger client
 *
 * Each saga watcher intercepts a trigger action, does the asyncrhonous work in the respective worker saga and dispatches a success or a failure action.
 * Fetch calls are made via the swagger tags interface requests
 *
 */

import { all, put, takeEvery } from "redux-saga/effects";
import { actions as collaboratorActions } from "./collaborators";
import { actions as communityAnnouncementActions } from "./communityAnnouncements";
import { actions as contentCategoryActions } from "./contentCategories";
import { actions as contractMediumActions } from "./contractMedia";
import { actions as contractActions } from "./contracts";
import { actions as contractTemplateActions } from "./contractTemplates";
import { actions as creatorCommentActions } from "./creatorComments";
import { actions as creatorActions } from "./creators";
import { actions as dashboardPanelActions } from "./dashboardPanels";
import { actions as eventRegistrationsActions } from "./eventRegistrations";
import { actions as eventActions } from "./events";
import { actions as faqsActions } from "./faqs";
import { actions as faqListsActions } from "./faqLists";
import { actions as faqListsFaqsActions } from "./faqListsFaqs";
import { actions as holderActions } from "./holders";
import { actions as milestoneActions } from "./milestones";
import { actions as mintTierActions } from "./mintTiers";
import { actions as mintVoucherActions } from "./mintVouchers";
import { actions as navigationItemActions } from "./navigationItems";
import { actions as partnerDealActions } from "./partnerDeals";
import { actions as projectBillingInfosActions } from "./projectBillingInfos";
import { actions as projectDashboardsActions } from "./projectDashboards";
import { actions as projectDesignsActions } from "./projectDesigns";
import { actions as projectOrdersActions } from "./projectOrders";
import { actions as projectActions } from "./projects";
import { actions as pushLinkActions } from "./pushLinks";
import { actions as raffleRegistrationsActions } from "./raffleRegistrations";
import { actions as raffleActions } from "./raffles";
import { actions as roadmapActions } from "./roadmaps";
import { actions as shopProductsOrderActions } from "./shopProductOrders";
import { actions as shopProductActions } from "./shopProducts";
import { actions as shopProductsBidActions } from "./shopProductsBids";
import { actions as tagsActions } from "./tags";
import { actions as tokenHistoryEventActions } from "./tokenHistoryEvents";
import { actions as tokenActions } from "./tokens";
import { actions as traitTypeActions } from "./traitTypes";
import { actions as traitTypesUnlockBoundariesActions } from "./traitTypesUnlockBoundaries";
import { actions as traitActions } from "./traits";
import { actions as tribeActions } from "./tribes";
import { actions as unlockActionActions } from "./unlockActions";
import { actions as unlockBoundaryActions } from "./unlockBoundaries";
import { actions as unlockHistoryEventsActions } from "./unlockHistoryEvents";
import { actions as unlockInputActions } from "./unlockInputs";
import { actions as unlockableContentActions } from "./unlockableContents";
import { actions as utilityContractActions } from "./utilityContracts";
import { actions as votesActions } from "./votes";
import { actions as votingOptionActions } from "./votingOptions";
import { actions as votingActions } from "./votings";
import { actions as walletProfileInputActions } from "./walletProfileInputs";
import { actions as walletProfileValueActions } from "./walletProfileValues";
import { actions as walletActions } from "./wallets";
import { actions as whitelistWalletActions } from "./whitelistWallets";
// What to do for a new resource?
// 1.) add Import
// import {actions as resourceNameActions} from './resourceName';
// 2.) add store included handlinge
// } else if (entry.type === "resource_name"){
//   return put({type: resourceNameActions.addToDictionary, payload: entry});
// }

/** Worker Sagas */
export function* storeIncluded(action) {
  yield all(
    action?.payload?.map((entry) => {
      if (entry.type === "project") {
        return put(projectActions.addToDictionary(entry));
      } else if (entry.type === "whitelist_entry") {
        return put(whitelistWalletActions.addToDictionary(entry));
      } else if (entry.type === "creator") {
        return put(creatorActions.addToDictionary(entry));
      } else if (entry.type === "wallet") {
        return put(walletActions.addToDictionary(entry));
      } else if (entry.type === "token") {
        return put(tokenActions.addToDictionary(entry));
      } else if (entry.type === "token_history_event") {
        return put(tokenHistoryEventActions.addToDictionary(entry));
      } else if (entry.type === "contract") {
        return put(contractActions.addToDictionary(entry));
      } else if (entry.type === "holder") {
        return put(holderActions.addToDictionary(entry));
      } else if (entry.type === "unlockable_content") {
        return put(unlockableContentActions.addToDictionary(entry));
      } else if (entry.type === "partner_deal") {
        return put(partnerDealActions.addToDictionary(entry));
      } else if (entry.type === "content_category") {
        return put(contentCategoryActions.addToDictionary(entry));
      } else if (entry.type === "voting") {
        return put(votingActions.addToDictionary(entry));
      } else if (entry.type === "voting_option") {
        return put(votingOptionActions.addToDictionary(entry));
      } else if (entry.type === "event") {
        return put(eventActions.addToDictionary(entry));
      } else if (entry.type === "unlock_boundary") {
        return put(unlockBoundaryActions.addToDictionary(entry));
      } else if (entry.type === "trait_type") {
        return put(traitTypeActions.addToDictionary(entry));
      } else if (entry.type === "trait") {
        return put(traitActions.addToDictionary(entry));
      } else if (entry.type === "trait_types_unlock_boundary") {
        return put(traitTypesUnlockBoundariesActions.addToDictionary(entry));
      } else if (entry.type === "event_registration") {
        return put(eventRegistrationsActions.addToDictionary(entry));
      } else if (entry.type === "vote") {
        return put(votesActions.addToDictionary(entry));
      } else if (entry.type === "unlock_history_event") {
        return put(unlockHistoryEventsActions.addToDictionary(entry));
      } else if (entry.type === "mint_tier") {
        return put(mintTierActions.addToDictionary(entry));
      } else if (entry.type === "mint_voucher") {
        return put(mintVoucherActions.addToDictionary(entry));
      } else if (entry.type === "tag") {
        return put(tagsActions.addToDictionary(entry));
      } else if (entry.type === "creator_comment") {
        return put(creatorCommentActions.addToDictionary(entry));
      } else if (entry.type === "unlock_input") {
        return put(unlockInputActions.addToDictionary(entry));
      } else if (entry.type === "unlock_action") {
        return put(unlockActionActions.addToDictionary(entry));
      } else if (entry.type === "project_creator") {
        return put(collaboratorActions.addToDictionary(entry));
      } else if (entry.type === "utility_contract") {
        return put(utilityContractActions.addToDictionary(entry));
      } else if (entry.type === "navigation_item") {
        return put(navigationItemActions.addToDictionary(entry));
      } else if (entry.type === "project_design") {
        return put(projectDesignsActions.addToDictionary(entry));
      } else if (entry.type === "project_dashboard") {
        return put(projectDashboardsActions.addToDictionary(entry));
      } else if (entry.type === "dashboard_panel") {
        return put(dashboardPanelActions.addToDictionary(entry));
      } else if (entry.type === "wallet_profile_input") {
        return put(walletProfileInputActions.addToDictionary(entry));
      } else if (entry.type === "wallet_profile_value") {
        return put(walletProfileValueActions.addToDictionary(entry));
      } else if (entry.type === "shop_product") {
        return put(shopProductActions.addToDictionary(entry));
      } else if (entry.type === "shop_product_bid") {
        return put(shopProductsBidActions.addToDictionary(entry));
      } else if (entry.type === "shop_product_order") {
        return put(shopProductsOrderActions.addToDictionary(entry));
      } else if (entry.type === "community_announcement") {
        return put(communityAnnouncementActions.addToDictionary(entry));
      } else if (entry.type === "contract_medium") {
        return put(contractMediumActions.addToDictionary(entry));
      } else if (entry.type === "project_billing_info") {
        return put(projectBillingInfosActions.addToDictionary(entry));
      } else if (entry.type === "project_order") {
        return put(projectOrdersActions.addToDictionary(entry));
      } else if (entry.type === "tribe") {
        return put(tribeActions.addToDictionary(entry));
      } else if (entry.type === "push_link") {
        return put(pushLinkActions.addToDictionary(entry));
      } else if (entry.type === "faq") {
        return put(faqsActions.addToDictionary(entry));
      } else if (entry.type === "faq_list") {
        return put(faqListsActions.addToDictionary(entry));
      } else if (entry.type === "faq_lists_faq") {
        return put(faqListsFaqsActions.addToDictionary(entry));
      } else if (entry.type === "roadmap") {
        return put(roadmapActions.addToDictionary(entry));
      } else if (entry.type === "milestone") {
        return put(milestoneActions.addToDictionary(entry));
      } else if (entry.type === "raffle") {
        return put(raffleActions.addToDictionary(entry));
      } else if (entry.type === "raffle_registration") {
        return put(raffleRegistrationsActions.addToDictionary(entry));
      } else if (entry.type === "contract_template") {
        return put(contractTemplateActions.addToDictionary(entry));
      } else return null;
    })
  );
}

// // Example for Updating relationships, rarely needed
// export function* updateRelationships(action) {
//   yield all(
//     action?.payload?.map((entry) => {
//       for (const rela in entry.relationships) {
//         const relationship = entry.relationships[rela];
//         if (relationship.data?.type === 'resource_name') {
//           return put({
//             type: resourceNameActions.addRelationship,
//             payload: {
//               id: relationship.data.id,
//               type: 'related_resource_name',
//               relationship: {id: entry.id, type: entry.type},
//             },
//           });
//         }
//       }
//       return null;
//     }),
//   );
// }

/**
 * Saga Watchers
 * The exported list of sagas registered. When one of the action types is dispatched
 * the related worker saga is invoked.
 * Each saga is executed in a different thread
 */
function* dictionarySagas() {
  yield takeEvery("dictionary/storeIncluded", storeIncluded);
  // yield takeEvery('dictionary/updateRelationships', updateRelationships);
}
export default dictionarySagas;
